<!--
 * @Author: LeeHuiXian
 * @version:
 * @Date: 2020-04-24 17:29:09
 * @LastEditors: LeeHuiXian
 * @LastEditTime: 2020-12-07 16:32:41
 * @FilePath: /wxweb-vue/Users/golden/Documents/WorkSpace/GdsWeb/goldenSalesMobile/src/views/SubmitOrder/index.vue
 * @Description: 支付订单
-->
<template>
  <div class='page-container'>
    <nav-bar title="支付订单" />

    <div class="tab-list">
      <van-list>
        <div
          class="goods-item"
          v-for="(subItem, subIndex) in orderDetails"
          :key="subIndex"
        >
          <div class="goods-image">
            <van-image
              :src="subItem.ProductImageUrl"
              fit="cover"
            />
          </div>
          <div class="goods-info">
            <p class="goods-name">{{ subItem.ProductName }}</p>
            <p class="goods-price">
              <span><a>￥</a>{{ subItem.SettlePrice }}</span>

              <span>x {{ subItem.Quantity }}</span>

              <!--                  <van-button-->
              <!--                          color="linear-gradient(to right, #FA9B00, #FBCA39)"-->
              <!--                          round-->
              <!--                  >-->
              <!--                    {{ subItem.Quantity }}-->
              <!--                  </van-button>-->
            </p>
          </div>
        </div>
      </van-list>
    </div>

    <van-field
      v-model="selectedCouponName"
      is-link
      label="可用优惠券"
      :placeholder="selectedCouponPlaceHolder"
      @focus="onCouponFocus"
      input-align="right"
    />
    <van-action-sheet
      v-model="showCoupons"
      :round="false"
      :actions="coupons"
      @select="onSelect"
    />

    <van-cell title="合计">
      <span style="color: #FE4600;font-size: 20px;font-weight:bold">￥ {{ originalAmount }}</span>
    </van-cell>

    <van-cell
      title="优惠"
      v-show="minusAmount"
    >
      <span style="color: #FE4600;font-size: 20px;font-weight:bold">－￥ {{ minusAmount }}</span>
    </van-cell>

    <van-cell title="应付">
      <span style="color: #FE4600;font-size: 20px;font-weight:bold">￥ {{ amount }}</span>
    </van-cell>

    <div class="fixed-btn">
      <van-button
        block
        :color="'linear-gradient(to right, #FA9B00, #FBCA39)'"
        @click="onSubmit"
      >
        立刻支付
      </van-button>
    </div>
  </div>
</template>

<script>
// import VerifyCode from '@/components/VerifyCode/index'
import { mobileReg } from '@/utils/index'
import { submitOrder, payOrder, getOrderDetail } from '@/api/order'
import { getUserCouponList } from '@/api/coupon'
// import { getBrandWCPayRequest } from '@/utils/wxpay'
// import { wxPay } from '@/api/pay'
// import { login, getMsCode } from '@/api/user'
// import { getShouqianbaConfig } from '@/api/system'
import { sqbWxPay, sqbH5Pay } from '@/api/pay'
import { getImagebaseUrl } from "../../utils";

export default {
  // components: { VerifyCode },

  data() {
    return {
      orderId: this.$route.params.id,
      sequenceId: null,
      orderDetails: [],
      selectedCouponTypeId: null,
      selectedId: null,
      selectedCouponName: null,
      selectedCouponPlaceHolder: '无',
      showCoupons: false,
      coupons: [],
      amount: null,
      minusAmount: null,
      originalAmount: null,
      payWay: 3, // 支付方式，3：微信，1：支付宝
      payWayText: '微信支付',
      userId: '', // 用户id，微信内置浏览器为openid，其他环境为系统的userId
      terminalSN: '', // 收钱吧终端序列号
      terminalSK: '', // 收钱吧终端秘钥
      isWeChatClient: true
    }
  },

  async created() {
    const orders = await getOrderDetail({ query: { id: this.orderId } })
    const order = orders.Items[0]
    this.sequenceId = order.SequenceId
    this.orderDetails = order.Details
    this.amount = order.Receipts;
    this.originalAmount = order.Receipts;
    const couponItems = await getUserCouponList({
      query: {
        Status: 0,
        ProductIds: order.Details.map(m => m.ProductId),
        IsLimitCurrentDay: true,
        Amount: this.originalAmount
      },
      Pager: { PageSize: 1000 }
    })
    if (couponItems && couponItems.Items && couponItems.Items.length > 0) {
      this.selectedCouponPlaceHolder = '选择 '
      this.coupons.push({ name: '', value: '', subname: '不选择优惠券' });
      couponItems.Items.map(m => {
        let subname = ''
        if (m.CouponRuleType.Id === 0) {
          subname = `满${m.CouponPrice}减${m.CouponSale}`
        }
        else if (m.CouponRuleType.Id === 1) {
          let count = m.CouponSale.toString()
          if (count.length > 1 && count.substr(1, 1) == '0') {
            count = count.substr(0, 1)
          }
          subname = `满${m.CouponPrice}打${count}折`
        }
        this.coupons.push({
          name: `${m.CouponName}(${m.CouponNumber})`,
          value: m.Id,
          subname: subname,
          typeid: m.CouponType.Id,
          ruletypeid: m.CouponRuleType.Id,
          price: m.CouponPrice,
          sale: m.CouponSale
        });
      })
    }
  },

  methods: {
    // 支付订单
    onSubmit() {
      let param = {
        OrderId: this.orderId,
        PayDetails: [{
          PayMethodTypeId: 0,      //wechat
          PayMethodId: null,
          Receipts: this.amount
        }]
      }
      if (this.selectedId) {
        param.PayDetails.push({
          PayMethodTypeId: this.selectedCouponTypeId,
          PayMethodId: this.selectedId,
          Receipts: this.minusAmount
        })
      }
      const result = payOrder(param)
      if (result) {
        // sessionStorage.setItem('pageBeforeLogin', 'submitOrder')
        // 回调H5支付接口
        this.onPay(this.sequenceId, this.orderId)
      }
    },

    // 支付
    onPay(sequenceId, orderId) {
      // let returnUrl = location.href.split('#')[0] + '#/users/users-order'
      let returnUrl = location.href.split('#')[0] + '#/goods/order'
      returnUrl = location.href.split('#')[0] + '#/consumecode-detail/' + orderId;
      let payRequest = ''
      let requestParams = {
        OutTradeNo: sequenceId,
        Subject: `金贵票务${orderId}`,
        Fee: Number(this.amount * 100),
        //Fee: Number(0.01 * 100),
        Payway: this.payWay,
        // UserId: this.userId,
        ReturnUri: returnUrl,
        // ClientId: 2
      }
      if (this.isWeChatClient) {
        payRequest = sqbWxPay // 微信内置浏览器环境下，调用收钱吧公众号支付
      } else {
        payRequest = sqbH5Pay // 其他环境下调用收钱吧H5支付
        requestParams.SubPayway = 6
        requestParams.UserIp = localStorage.getItem('Ip')
      }
      payRequest(requestParams)
        .then(res => {
          if (res) {
            // 支付跳转链接
            if (this.isWeChatClient) {
              location.href = res
            } else if (res.wap_pay_request.h5_pay_redirect_url) {
              location.href = `${res.wap_pay_request.h5_pay_redirect_url}&redirect_url=${encodeURIComponent(returnUrl)}`
            }
          }
        })
        .catch(err => {
          // console.log(err)
        })
    },

    onCouponFocus() {
      if (this.coupons.length === 0) return
      this.showCoupons = true;
    },

    onSelect(item) {
      this.showCoupons = false;
      this.selectedCouponTypeId = 1;
      this.selectedId = item.value;
      this.selectedCouponName = item.name;
      if (this.selectedId) {
        if (this.originalAmount >= item.price) {
          if (item.ruletypeid === 0) {
            this.minusAmount = item.sale
            this.amount = this.originalAmount - item.sale
          }
          else if (item.ruletypeid === 1) {
            this.minusAmount = (100 - item.sale) / 100 * this.originalAmount
            this.amount = item.sale / 100 * this.originalAmount
          }
        }
      }
      else {
        this.minusAmount = null
        this.amount = this.originalAmount;
      }
    },

  }
}
</script>

<style lang='scss' scoped>
.page-container {
  .tab-list {
    width: 100%;
    background: #ffffff;
    margin-bottom: 20px;

    .goods-item {
      @include border-box(22px 32px);
      @include flex-box();

      .goods-image {
        flex: none;
        width: 260px;
        height: 260px;
        margin-right: 20px;
        border-radius: 12px;
        overflow: hidden;

        &::v-deep .van-image {
          width: 100%;
          height: 100%;
        }
      }

      .goods-info {
        flex: 1;

        .goods-name {
          margin-bottom: 12px;
          line-height: 48px;
          font-size: 34px;
          font-weight: 500;
          color: #333333;
        }

        .goods-intro,
        .goods-salesCount {
          min-height: 34px;
          margin-bottom: 10px;
          line-height: 34px;
          font-size: 24px;
          color: #888888;
        }

        .goods-salesCount {
          > a > b {
            font-weight: normal;
            text-decoration: line-through;
          }
        }

        .goods-name,
        .goods-intro {
          display: -webkit-box;
          -webkit-box-orient: vertical;
          -webkit-line-clamp: 2; // 用来限制在一个块元素显示的文本的行数
          overflow: hidden;
        }

        .goods-price {
          @include flex-box(space-between);

          > span {
            line-height: 30px;
            font-size: 40px;
            font-weight: bold;
            color: #fe4600;

            > a {
              font-size: 24px;
            }
          }

          &::v-deep .van-button {
            width: 90px;
            height: 30px;
            line-height: 30px;

            .van-button__text {
              font-weight: 500;
            }
          }
        }
      }
    }
  }
}
</style>

